import * as yup from 'yup';
export const newProductForm = {
 unregisterFields: {
  product: ['composition', 'specifications'],
  recipe: ['quantity', 'article', 'regularPrice'],
  combo: ['quantity', 'article', 'regularPrice']
 },
 defaultValues: {
  name: '',
  type: 'product',
  stock: null,
  tags: [],
  categories: [],
  financings: [],
  description: '',
  shortDescription: ''
 },
 schema: yup
  .object({
   name: yup.string().required(),
   type: yup.string().oneOf(['product', 'recipe', 'combo']).required(),
   stock: yup.string().oneOf(['inventory', 'available', 'unavailable']).required(),
   article: yup.string().when('type', {
    is: 'product',
    then: schema => schema.required(),
    otherwise: schema => schema.notRequired()
   }),
   quantity: yup.number().when('type', {
    is: 'product',
    then: schema =>
     schema
      .transform((value, originalValue) => (originalValue === '' ? undefined : Number(originalValue)))
      .positive('quantity 2 must be a positive number')
      .required(),
    otherwise: schema => schema.notRequired()
   }),
   regularPrice: yup.number().when('type', {
    is: 'product',
    then: schema => schema.required(),
    otherwise: schema => schema.notRequired()
   }),
   price: yup.number().when('type', {
    is: value => ['recipe', 'combo'].includes(value),
    then: schema => schema.required(),
    otherwise: schema => schema.notRequired()
   }),
   image: yup
    .array()
    .of(
     yup
      .mixed()
      .required('A file is required')
      .test('is-file-or-url', 'Each item must be a URL or a file object', value => {
       if (typeof value === 'string') {
        const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)\S*$/i;
        return urlPattern.test(value);
       } else if (value && typeof value === 'object' && value.type && value.size) {
        return value.type.startsWith('image/');
       }
       return false;
      })
    )
    .required('Files are required')
    .min(1, 'At least one file or URL is required')
    .max(1, 'You can only upload up to 1 files or URLs'),
   composition: yup.array().when('type', {
    is: value => ['recipe', 'combo'].includes(value),
    then: schema =>
     schema.of(
      yup.object({
       item: yup.string().required(),
       references: yup.array().of(yup.string().required()).required(),
       quantity: yup
        .number()
        .transform((value, originalValue) => (originalValue === '' ? undefined : Number(originalValue)))
        .required()
        .positive('quantity 2 must be a positive number')
      })
     ),
    otherwise: schema => schema.notRequired()
   }),
   pricingReference: yup.array().of(
    yup.object({
     price: yup.number().required(),
     references: yup.array().of(yup.string().required()).required().min(1)
    })
   ),
   specifications: yup
    .array()
    .of(
     yup.object({
      label: yup.string().required(),
      property: yup.string().required()
     })
    )
    .notRequired(),
   tags: yup.array().of(yup.string().required()).required().min(1),
   categories: yup.array().of(yup.string().required()).required().min(1),
   description: yup.string().required(),
   shortDescription: yup.string().required(),
   products: yup
    .array()
    .of(
     yup.object({
      tag: yup.string().required(),
      quantity: yup.string().required(),
      status: yup.string().required(),
      stock: yup.string().notRequired(),
      description: yup.string().nullable().notRequired(),
      references: yup.array().of(yup.string().required()).required().min(1)
     })
    )
    .notRequired(),
   financings: yup
    .array()
    .of(
     yup.object({
      id: yup.string(),
      name: yup.string().required(),
      minInitialPay: yup.number().required(),
      initialFee: yup.number().required(),
      maxInitials: yup.number().notRequired(),
      minFeeIni: yup.number().notRequired(),
      maxFinancing: yup.number().notRequired(),
      minFeeFnc: yup.number().notRequired(),
      lateFee: yup.number().notRequired(),
      rate: yup.number().nullable().notRequired(),
      amortize: yup.number().nullable().notRequired()
     })
    )
    .notRequired(),
   images: yup
    .array()
    .of(
     yup
      .mixed()
      .required('A file is required')
      .test('is-file-or-url', 'Each item must be a URL or a file object', value => {
       if (typeof value === 'string') {
        const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)\S*$/i;
        return urlPattern.test(value);
       } else if (value && typeof value === 'object' && value.type && value.size) {
        return value.type.startsWith('image/');
       }
       return false;
      })
    )
    .notRequired()

   //  regularPrice: yup
   //   .number()
   //   .transform(v => noCurrency(v))
   //   .nullable()
   //   .required(),
   //  image2: yup.mixed().when('type', {
   //   is: value => ['recipe', 'combo'].includes(value),
   //   then: yup
   //    .mixed()
   //    .required('A file is required')
   //    .test('fileType', 'Only image files are allowed', value => value && value.type && value.type.startsWith('image/'))
   //    .test('fileSize', 'File size must be less than 2MB', value => value && value.size && value.size <= 2 * 1024 * 1024),
   //   otherwise: yup.notRequired()
   //  })
  })
  .required(),
 defaultValuesRating: {
  rating: 0,
  text: '',
  author: { name: '', email: '' }
 },
 schemaRating: yup
  .object({
   rating: yup.number().required().min(0.5),
   title: yup.string().notRequired(),
   author: yup
    .object({
     name: yup.string().required(),
     email: yup.string().email('El email no es válido').required('El email es requerido')
    })
    .required(),
   text: yup.string().required()
  })
  .required()
};
